import "@/index.css";
import { initSentry } from '@deliveryteam-spa-orders-vue/instrument';
import { createApp, watch } from 'vue'
import App from './App.vue'
import { authState, waitUntilReady } from '@/ui-plus/useAuth';
import { pkceCheckAuthParams } from "@/ui-plus/auth/auth.pkce.redirect";
import { loadCourierProfile } from "./refs/CourierProfile";
import { tryStartGeolocationWatchIfAlreadyGranted } from "./refs/UserCurrentLocation";
import "./native";

function startIfAuthed() {
    if (authState.value.accessTokenPayload === null) return false;
    // If permission is already granted, start here; otherwise Orders home starts on button tap (gesture).
    void tryStartGeolocationWatchIfAlreadyGranted();
    loadCourierProfile();
    return true;
}

waitUntilReady.then(async () => {
    await pkceCheckAuthParams();
    if (!startIfAuthed()) {
        const stop = watch(authState, (s) => {
            if (s?.accessTokenPayload !== null) {
                startIfAuthed();
                stop();
            }
        });
    }
    const app = createApp(App);
    initSentry(app);
    app.mount('#app');
});

// refresh in bg is not good, it brokes slient audio loop
// setTimeout(() => {
//     window.location.reload();
// }, 6 * 60 * 60 * 1000); // reload after 6 hours
